import React from "react";
import { useParams, Navigate } from "react-router-dom";
import CenterSettings from "views/admin/center-settings";

const CenterSettingsView = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <CenterSettings centerId={centerId} />;
};

export default CenterSettingsView;
